import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import headerRightBg from '../images/documents/headerRightBg.png';
import headerRightBg375 from '../images/documents/headerRightBg375.png';
import DocumentsExchangeManWoman from '../images/documents/DocumentsExchangeManWoman.svg';
import EmailContactSales from '../components/EmailContactSales';
import ProblemSolution from '../components/ProblemSolution';
import FeaturesAndBenefits from '../components/FeaturesAndBenefits';
import DocumentEye from '../images/documents/DocumentEye.svg';
import GearPen from '../images/documents/GearPen.svg';
import AtomDocument from '../images/documents/AtomDocument.svg';
import IpadScreenshot from '../images/documents/IpadScreenshot.png';
import WantToSeeHow from '../components/WantToSeeHow';
import FinancialInstitutions from '../components/FinancialInstitutions';

const HeaderContent = styled.article`
	padding-bottom: 1em;
	display: flex;
	flex-direction: column;

	& h1 {
		min-height: 0;
	}

	& p {
		max-width: 490px;
		@media (${(props) => props.theme.mediumUp}) {
			font-size: 30px;
		}
	}
`;

const DocumentsHeaderContent =
	<HeaderContent style={{marginTop: `0`, paddingTop: `75px`, paddingBottom: `60px`}}>
		<h1>Documents</h1>
		<p>Dynamic document<br />generation engine</p>
		<EmailContactSales />
	</HeaderContent>
;

const HeaderBottomContentFigure = styled.figure`

	& svg.bottomAligned {
		max-width: 90%;
		margin-top: 1em;
		margin-bottom: 2em;

		@media (${(props) => props.theme.mediumUp}) {
			max-width: 100%;
			margin-top: 0;
			margin-bottom: 2em;
		}

		@media (${(props) => props.theme.largeUp}) {
			max-width: 484px;
			margin-bottom: 4em;
		}

		@media (${(props) => props.theme.xLargeUp}) {
			max-width: 100%;
			margin-bottom: 4em;
		}
	}
`;

const DocumentsExchangeManWomanFigure =
	<HeaderBottomContentFigure>
		<DocumentsExchangeManWoman alt='Man at desk looking at connected apps' className='bottomAligned' />
	</HeaderBottomContentFigure>
;

const Section = styled.section`
	border: none;

	&#DocumentsSplit {
		@media all and (-ms-high-contrast: none) {
			& img {
				max-width: 345px;
				max-height: 189px;
			}
		}

		@media (${(props) => props.theme.smallUp}) and (-ms-high-contrast: none) {
			& img {
				max-width: 691px;
				max-height: 381px;
			}
		}

		@media (${(props) => props.theme.mediumUp}) and (-ms-high-contrast: none) {
			& img {
				max-width: 326px;
				max-height: 179px;
			}
		}

		@media (${(props) => props.theme.largeUp}) and (-ms-high-contrast: none) {
			& img {
				max-width: 421px;
				max-height: 230px;
			}
		}

		@media (${(props) => props.theme.xLargeUp}) and (-ms-high-contrast: none) {
			& img {
				max-width: 588px;
				max-height: 322px;
			}
		}
	}
`;

const FeaturesAndBenefitsSyle = { marginBottom: '0' };

const DocumentsPage = (props: any) => {
	return (
	<Layout
		headerSplashBg375={headerRightBg375}
		headerSplashBgSize={'100% 100%'}
		headerSplashBgPosition={'center top'}
		headerSplashBg={headerRightBg}
		headerSplashBgSizeLarge={'auto'}
		headerSplashBgPositionLarge={'center bottom'}
		headerSplashAlignItemsLarge={'flex-end'}
		headerBottomContent={DocumentsExchangeManWomanFigure}
		headerContentClass={'product'}
		headerContent={DocumentsHeaderContent}
		headerContentMaxWidth={'490px'}
		headerSplashBgAverageColor={'white'}
		pageTitle='Documents - Automated document preparation'
		metaDescription={'Deliver top-notch legal documents for customer review with an automated system that takes the document preparation out of your hands.'}
		skipMoney2020={true}
		splashHeaderMinHeight={'500px'}
		BodyClass={'Documents'}
	>
		<ProblemSolution
			problem={'Preparing and processing legally binding documents is time-consuming. Additionally, errors from manual, repetitive data entry present compliance risks.'}
			solution={'Documents integrates with your lending workflows to expedite agreement and disclosure assembly for each stage in the loan process.'}
		/>
		<FeaturesAndBenefits
			extraStyle={FeaturesAndBenefitsSyle}
			solidBgColor = {'#3d80ac'}

			leftIcon = {<DocumentEye alt='digital document and eye icon' style={{margin: `0`}} />}
			leftHeading = {'Digitized terms\nand conditions'}
			leftText={'Scale your lending operations to support multiple loan types.'}

			middleIcon = {<GearPen alt='Gear with pencil icon' style={{margin: `29px 0 0 0`}} />}
			middleHeading = {'Autofilled customer\ninformation'}
			middleText = {'Reduce duplicate data entry and curb human error.'}

			rightIcon = {<AtomDocument alt='changing doucment icon' style={{margin: `5px 0 0 0`}} />}
			rightHeading = {'Dynamic\nrequirements'}
			rightText = {'Populate your documents with federal and state compliance regulations.'}
		/>
		<div className='centeredWrapper'>
			<Section className='fast-simple row row-flush centered' id='DocumentsSplit'>
				<article className='col-12 col-md-6 right-on-desktop'>
					<div className='product text-box'>
						<header>
							<h2>Transform your operations<br />with automation</h2>
						</header>
						<p>Manually producing paperwork for each step in the customer journey is cumbersome. Transform your lending operations with our seamless document generation system to alleviate your back office workload.</p><p>In one fell swoop, digitally prepare, process, and deliver loan agreements for customer review. With automation on your side, the potential to create top-notch documents is endless.</p>
					</div>
				</article>
				<figure className='col-12 col-md-6'>
					<img src={IpadScreenshot} alt='iPad Screenshot' />
				</figure>
			</Section>
			{/* <FinancialInstitutions /> */}
			<WantToSeeHow />
		</div>
	</Layout>
	);
};

export default DocumentsPage;
